import { render, staticRenderFns } from "./ScrollView.vue?vue&type=template&id=3010e08c&scoped=true"
import script from "./ScrollView.vue?vue&type=script&lang=js"
export * from "./ScrollView.vue?vue&type=script&lang=js"
import style0 from "./ScrollView.vue?vue&type=style&index=0&id=3010e08c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3010e08c",
  null
  
)

export default component.exports